module.exports = __webpack_public_path__ + "baby.jpg?c8d5118910f22249e0c6f9d02cc47d38";